module.exports = __webpack_public_path__ + "img/logo.d92340ee.png";